import React from 'react';
import { USERS } from "../../common/const/const";
import "./Users.scss";
import classNames from "classnames";

const Users = ({
    users,
    isLoading,
    create,
    remove
}) => {
    return (
        <div className="Main__container">
            <div className="Main__menu-country">
                <div className="Main__menu-country_item">
                    <div>{ USERS.users }:</div>
                </div>
                <ul>
                { ! isLoading ? users.map((user, key) => {
                        return (
                            <li key={key}>{ user.email } <span onClick={() => remove(user.email)} className="Remove_button">&#x2297;</span></li>
                        )
                    }): <h3>Loading...</h3>
                }
                </ul>
            </div>
            <div className="Main__content">
                <div className="Main__content-form">
                    <Form
                        create={create}
                    />
                </div>
            </div>
        </div>
    );
};

const Form = ({
      create
}) => {
    const [emailValue, setEmailValue] = React.useState("");
    const [validEmail] = React.useState(true);

    const onChangeEmail = React.useCallback(event => {
        event.preventDefault();
        const {value} = event.currentTarget;
        setEmailValue(value);
    }, []);

    return (
        <form name="entrance">
            <label htmlFor="email">
                <input
                    value={emailValue}
                    onChange={onChangeEmail}
                    className={classNames('Entrance__input', {
                        'Entrance__input_error': !validEmail
                    })}
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Введите email"
                />
            </label>
            <button className="UsersEntrance__btn" type="button" onClick={() => create(emailValue)}>
                Добавить пользователя
            </button>
        </form>
    )
}

export default Users;
